import registerUserService from "services/maintenance/userService";
import userGroupResource from "features/maintenance/resources/userGroupResource";
import { PersonAddOutlined } from "@mui/icons-material";
import personResource from "features/maintenance/resources/personResource";

const isEditing = (formData) => {
    return !!formData?.id;
};

const registerUserResource = {
    title: "User",
    singular: "User",
    displayField: "username",
    pageIcon: PersonAddOutlined,

    service: registerUserService,

    columns: [
        {
            field: "username",
            header: "User"
        },
        {
            field: "employeeName",
            header: "Assigned Employee"
        },
        {
            field: "roles",
            header: "User Group"
        }
    ],

    fields: [
        {
            name: "username",
            label: "User Name",
            type: "text",
            required: true,
            unique: true
        },
        {
            name: "temporaryPassword",
            label: "Temporary Password(Will be auto-generated)",
            type: "password",
            disabled: true,
            required: false,
            showRequirements: false
            //disabledResolver: isEditing
        },
        {
            name: "roles",
            label: "User Group",
            type: "lookup",
            required: true,
            resource: userGroupResource,
            lookupField: "name"

            // disabled: true
        },
        {
            name: "employeeName",
            label: "Assigned Employee",
            type: "lookup",
            required: true,
            resource: personResource,
            lookupField: "fullName",
            sourceDataField: "employee.id",
            targetDataField: "employeeId",
            filterValues: (items) => items.filter((item) => !item.userId)
        }
    ],
    searchFields: ["username"]
};

export default registerUserResource;
